import { render, staticRenderFns } from "./safOpinionBoardManageDetail.vue?vue&type=template&id=6c5bfc21"
import script from "./safOpinionBoardManageDetail.vue?vue&type=script&lang=js"
export * from "./safOpinionBoardManageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c5bfc21')) {
      api.createRecord('6c5bfc21', component.options)
    } else {
      api.reload('6c5bfc21', component.options)
    }
    module.hot.accept("./safOpinionBoardManageDetail.vue?vue&type=template&id=6c5bfc21", function () {
      api.rerender('6c5bfc21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/sob/safOpinionBoardManageDetail.vue"
export default component.exports